<!--
 * @Author: zhouwei
 * @Date: 2020-04-10 11:03:52
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-04-15 16:35:47
 * @Description: 创建/编辑学习任务
 -->
<template>
  <div class="task">
    <create-header
      ref="createHeader"
      :title="!isEdit ? '新建学习任务' : (canNotEdit ? '任务发布详情' : '编辑学习任务')"
      :need-back-txt="!canNotEdit"
      :back-txt="backTxt"
      @othter-click="confirm('publish')"
    />
    <back-to-top
      :right="20"
      :bottom="78"
      @to-top="toTop"
    />
    <div class="form">
      <div
        ref="formContent"
        class="form-content"
      >
        <mk-form
          ref="form"
          :model="params"
          :rules="rules"
        >
          <mk-form-item
            ref="name"
            class="mk-form-item-name"
            prop="name"
            label="任务名称："
            label-width="120px"
          >
            <mk-input
              v-model.trim="params.name"
              placeholder="请输入任务名称"
              width="370"
              maxlength="20"
              show-word-limt
              :disabled="canNotEdit"
              @input="nameInput"
            >
              <div slot="suffix">
                <span>{{ params.name.length }}</span>
                <span>/20</span>
              </div>
            </mk-input>
          </mk-form-item>
          <mk-form-item
            class="mk-form-item-end-time"
            prop="endTime"
            label="参与结束时间："
            label-width="120px"
          >
            <mk-date-picker
              v-model="params.endTime"
              type="date"
              size="small"
              placeholder="不限"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              :disabled="canNotEdit"
              :picker-options="pickerOptions"
            />
          </mk-form-item>
          <mk-form-item
            ref="dmList"
            class="mk-form-item-dm-list"
            prop="dmList"
            label="执行成员："
            label-width="120px"
          >
            <dept-member-select
              v-model="params.dmList"
              width="320"
              :can-select-company="true"
              :disabled="canNotEdit"
              @optionVisibleChange="optionVisibleChange"
              @change-ids="changeIds"
            />
          </mk-form-item>
          <mk-form-item
            ref="courseExamList"
            class="mk-form-item-task-content"
            prop="courseExamList"
            label="任务内容："
            label-width="120px"
          >
            <div
              v-if="!canNotEdit"
              class="add-btn"
            >
              <mk-button-biz
                class="add-course"
                icon="el-icon-plus"
                @click="addCourse"
              >
                添加课程
              </mk-button-biz>
              <mk-button-biz
                class="add-course"
                icon="el-icon-plus"
                @click="addExam"
              >
                添加考试
              </mk-button-biz>
            </div>
            <div
              v-if="params.courseExamList.length > 0"
              class="course-exam-list"
            >
              <div
                v-for="(item,index) in params.courseExamList"
                :key="index"
                class="course-exam-list-item"
              >
                <div class="info">
                  <img
                    v-if="item.type === 1 || item.type === 3"
                    src="@/assets/images/course.png"
                  />
                  <img
                    v-else
                    src="@/assets/images/exam.png"
                  />
                  <div class="main-info">
                    <div class="main-info-name">
                      {{ item.name }}
                    </div>
                    <div class="main-info-condition">
                      完成条件: {{ item.type === 1 || item.type === 3 ? '确认完成学习' : '提交考试' }}
                    </div>
                  </div>
                </div>
                <div
                  v-if="!canNotEdit"
                  class="hanlde-item"
                >
                  <mk-button-biz
                    v-if="index !== 0"
                    type="text"
                    class="hanlde-item-btn"
                    @click="move('prev',index)"
                  >
                    上移
                  </mk-button-biz>
                  <mk-button-biz
                    v-if="index !== params.courseExamList.length - 1"
                    type="text"
                    class="hanlde-item-btn"
                    @click="move('next',index)"
                  >
                    下移
                  </mk-button-biz>
                  <mk-button-biz
                    type="text"
                    class="hanlde-item-btn"
                    @click="move('delete',index)"
                  >
                    删除
                  </mk-button-biz>
                </div>
              </div>
            </div>
          </mk-form-item>
        </mk-form>
      </div>
    </div>
    <create-footer v-if="!canNotEdit">
      <mk-button-biz
        width="84px"
        font-size="13px"
        @click="checkFormData('save')"
      >
        保存任务
      </mk-button-biz>
      <mk-button-biz
        type="primary"
        width="96px"
        font-size="13px"
        @click="checkFormData('publish')"
      >
        发布任务
      </mk-button-biz>
    </create-footer>
    <add-course
      v-if="courseVisible"
      :key="Number(new Date().getTime()) + 'course'"
      :college-name="collegeName"
      :visible="courseVisible"
      title="课程"
      :choose-list="chooseCourseList"
      @cancel="cancel"
      @confirm="confirmAddCourse"
    />
    <add-exam
      v-if="examVisible"
      :key="Number(new Date().getTime()) + 'exam'"
      :visible="examVisible"
      title="考试"
      :choose-list="chooseExamList"
      @cancel="cancel"
      @confirm="confirmAddExam"
    />
    <!-- <mk-dialog-confirm
      :visible.sync="isShowConfirmDialog"
      v-bind="confirmDialogData"
      append-to-body
      @on-confirm="onConfirm"
    /> -->
  </div>
</template>
<script>
import createHeader from '@components/create-header'
import createFooter from '@components/create-footer'
import backToTop from '@components/back-to-top'
import deptMemberSelect from '@components/dept-member-select-biz'
import MkDrawerBizTwo from '@components/mk-drawer-biz-two'
import addCourse from '../components/add-course'
import addExam from '../components/add-exam'
import { MBASVCAPIS, ACCOUNTAPIS } from '@api'
import getCollegeName from '@utils/get-college-name'
export default {
  components: {
    deptMemberSelect,
    addCourse,
    createHeader,
    createFooter,
    backToTop,
    addExam
  },
  data () {
    var checkRules = (rule, value, callback) => {
      if ((value.dept.length > 0 || value.member.length > 0) && !this.isCheckoutDmList) {
        return callback()
      } else {
        return callback(new Error('请选择部门或成员'))
      }
    }
    var checkCourseExamListRules = (rule, value, callback) => {
      if (value && value.length > 0) {
        return callback()
      } else {
        return callback(new Error('请添加任务内容'))
      }
    }
    return {
      params: {
        name: '',
        endTime: '',
        dmList: { dept: [], member: [] },
        courseExamList: [],
        status: 1
      },
      show: false,
      rules: {
        name: [
          {
            required: true,
            message: '请输入任务名称',
            trigger: 'blur'
          }
        ],
        dmList: {
          validator: checkRules,
          required: true,
          trigger: 'blur'
        },
        courseExamList: {
          validator: checkCourseExamListRules,
          required: true,
          trigger: 'blur'
        }
      },
      courseVisible: false,
      examVisible: false,
      isEdit: false,
      isCheckoutDmList: false,
      status: 0,
      pickerOptions: {
        disabledDate (time) {
          // return time.getTime() < Date.now() - 24 * 60 * 60 * 1000 - 8.64e6
          return time.getTime() < new Date() - 24 * 60 * 60 * 1000
        }
      },
      backTxt: '该学习任务还未保存，确认返回吗？',
      max: 100, // 任务内容最多可添加项数
      isShowConfirmDialog: false,
      confirmDialogData: {
        title: '发布提示',
        tip: '任务发布后不能再编辑内容，确认发布吗？',
        iconColor: '#009cff',
        iconClass: 'tixing',
        closeBtn: {
          type: 'default',
          color: '#595959',
          text: '取 消',
          isShow: true
        },
        confirmBtn: {
          type: 'primary',
          color: '#fff',
          text: '确认',
          isShow: true
        }
      },
      type: ''
    }
  },
  computed: {
    canNotEdit () {
      if (this.$route.query.status === '2' || this.$route.query.status === 2 || this.$route.query.status === '3' || this.$route.query.status === 3) {
        return true
      } else {
        return false
      }
    },
    chooseCourseList () {
      let arr = []
      if (this.params && this.params.courseExamList instanceof Array) {
        this.params.courseExamList.forEach(item => {
          if (item.type === 1 || item.type === 3) {
            arr.push(item._id)
          }
        })
      }
      return arr
    },
    chooseExamList () {
      let arr = []
      if (this.params && this.params.courseExamList instanceof Array) {
        this.params.courseExamList.forEach(item => {
          if (item.type === 2) {
            arr.push(item._id)
          }
        })
      }
      return arr
    }
  },
  watch: {
    'params.courseExamList': {
      handler (val) {
        this.$refs.courseExamList.clearValidate()
      },
      // immediate: true, // 刷新加载 立马触发一次handler
      deep: true // 可以深度检测到 params 对象的属性值的变化
    }
  },
  created () {
    if (this.$route.query.edit) {
      this.getDetail(this.$route.query.id)
      this.isEdit = true
    }
    this.status = this.$route.query.status
    this.collegeName = getCollegeName()
  },
  methods: {
    onConfirm () {
      this.confirm()
    },
    nameInput () {
      if (this.params.name !== '') {
        this.$refs.name.clearValidate()
      }
    },
    changeIds (data) {
      if (data.deptId.length > 0 || data.memberId.length > 0) {
        this.$refs.dmList.clearValidate()
      }
    },
    // 回到顶部
    toTop () {
      this.$refs.formContent.scrollTop = 0
    },
    // 判断选择时是否 展示
    optionVisibleChange (val) {
      this.isCheckoutDmList = val
    },
    uniq (arr) {
      let len = arr.length
      for (var i = 0; i < len; i++) {
        for (var j = i + 1; j < len; j++) {
          if (arr[i] && arr[j] && arr[i]._id === arr[j]._id) {
            // 第一个等同于第二个，splice方法删除第二个
            arr.splice(j, 1)
            j--
          }
        }
      }
      return arr
    },
    async getDetail (id) {
      const { data, success } = await MBASVCAPIS.MissionApi.missionDetailGet({
        _id: id,
        isShowEmployee: true,
        isShowCourseAndExam: true
      })
      if (success) {
        this.params.name = data.name
        if (data.isForever) {
          this.params.endTime = ''
        } else {
          if (data.endTime && data.endTime.indexOf(' ') > 0) {
            this.params.endTime = data.endTime.split(' ')[0]
          }
        }
        this.params.courseExamList = data.courseExamList
        this.params.status = data.status
        if (data.all) {
          this.params.dmList = {
            dept: [
              {
                id: 'NA',
                name: JSON.parse(window.localStorage.getItem('user')).accountName
              }
            ],
            member: []
          }
        } else {
          let dmList = {
            dept: [],
            member: []
          }
          data.departmentList.forEach(item => {
            dmList.dept.push({
              id: item._id,
              name: item.name
            })
          })
          data.employeeList.forEach(item => {
            dmList.member.push({
              id: item._id,
              name: item.name
            })
          })
          this.params.dmList = dmList
        }
      }
    },
    confirmAddCourse (data) {
      let result = []
      let arr = []
      data.forEach(item => {
        if (this.chooseCourseList.length > 0) {
          this.chooseCourseList.forEach(itemC => {
            if (item._id !== itemC) {
              arr.push({
                _id: item._id,
                name: item.name,
                condition: 1,
                description: item.description,
                type: item.type
              })
            }
          })
        } else {
          arr.push({
            _id: item._id,
            name: item.name,
            condition: 1,
            description: item.description,
            type: item.type
          })
        }
      })
      result = this.params.courseExamList.concat(arr)
      result = this.uniq(result)
      if (result.length > this.max) {
        this.$message({
          type: 'error',
          message: `任务内容最多可添加${this.max}项`,
          showClose: true
        })
      } else {
        this.courseVisible = false
        this.params.courseExamList = result
      }
    },
    confirmAddExam (data) {
      let result = []
      let arr = []
      data.forEach(item => {
        if (this.chooseExamList.length > 0) {
          this.chooseExamList.forEach(itemC => {
            if (item._id !== itemC) {
              arr.push({
                _id: item._id,
                name: item.name,
                condition: 3,
                description: item.description,
                type: 2
              })
            }
          })
        } else {
          arr.push({
            _id: item._id,
            name: item.name,
            condition: 3,
            description: item.description,
            type: 2
          })
        }
      })
      result = this.params.courseExamList.concat(arr)
      result = this.uniq(result)
      if (result.length > this.max) {
        this.$message({
          type: 'error',
          message: `任务内容最多可添加${this.max}项`,
          showClose: true
        })
      } else {
        this.examVisible = false
        this.params.courseExamList = result
      }
    },
    goBack () {
      this.$confirm('内容将不会被保存', '', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'none'
      }).then(() => {
        history.go(-1)
      })
    },
    checkFormData (type) {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (type !== 'save') {
            // this.$confirm('任务发布后不能再编辑内容，确认发布吗？', '', {
            //   confirmButtonText: '确认',
            //   cancelButtonText: '取消',
            //   type: 'none'
            // }).then(() => {
            //   this.confirm(type)
            // })
            this.$refs.createHeader.isShowConfirmDialog = true
            this.$refs.createHeader.confirmDialogData = this.confirmDialogData
            this.type = type
            this.$refs.createHeader.needEmit = true
            // this.isShowConfirmDialog = true
          } else {
            this.confirm(type)
          }
        } else {
          this.$refs.formContent.scrollTop = 0
        }
      })
    },
    async confirm (type) {
      // 创建/保存/发布任务
      let metas = {
        name: this.params.name,
        status: type === 'save' ? 1 : 2,
        courseExamList: this.params.courseExamList
      }
      if (this.isEdit) {
        metas._id = this.$route.query.id
      }

      if (this.params.dmList.dept.length === 1 && this.params.dmList.dept[0].id === 'NA' && this.params.dmList.member.length === 0) {
        metas.all = true
      } else {
        if (this.params.dmList.member.length > 0) {
          let userIds = []
          this.params.dmList.member.forEach(item => {
            userIds.push(item.id)
          })
          metas.userIds = userIds
        }
        if (this.params.dmList.dept.length > 0) {
          let departmentIds = []
          this.params.dmList.dept.forEach(item => {
            departmentIds.push(item.id)
          })
          metas.departmentIds = departmentIds
        }
      }
      if (this.params.endTime) {
        metas.endTime = this.params.endTime + ' 23:59:59'
      } else {
        metas.isForever = true
      }
      const { success } = await MBASVCAPIS.MissionApi.missionCreatePost(metas)
      if (success) {
        this.$message({
          type: 'success',
          message: this.isEdit ? (type === 'save' ? '保存成功' : '发布成功') : '创建成功'
        })
        this.$router.go(-1)
      }
    },
    addCourse () {
      if (this.params.courseExamList.length < this.max) {
        this.courseVisible = true
      } else {
        this.$message({
          type: 'error',
          message: `任务内容最多可添加${this.max}项`,
          showClose: true
        })
      }
    },
    addExam () {
      if (this.params.courseExamList.length < this.max) {
        this.examVisible = true
      } else {
        this.$message({
          type: 'error',
          message: `任务内容最多可添加${this.max}项`,
          showClose: true
        })
      }
    },
    // 取消选择
    cancel () {
      this.examVisible = false
      this.courseVisible = false
    },
    move (type, index) {
      // 上下移动, 删除
      if (type === 'prev') {
        if (index !== 0) {
          let item = this.params.courseExamList[index]
          this.params.courseExamList[index] = this.params.courseExamList[index - 1]
          setTimeout(() => {
            this.params.courseExamList[index - 1] = item
            this.params.courseExamList = this.params.courseExamList.concat([])
          }, 0)
        }
      } else if (type === 'next') {
        if (index !== this.params.courseExamList.length - 1) {
          // this.params.courseExamList
          let item = this.params.courseExamList[index]
          this.params.courseExamList[index] = this.params.courseExamList[index + 1]
          setTimeout(() => {
            this.params.courseExamList[index + 1] = item
            this.params.courseExamList = this.params.courseExamList.concat([])
          }, 0)
        }
      } else if (type === 'delete') {
        this.params.courseExamList.splice(index, 1)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.task {
  height: 100%;
  display: flex;
  flex-direction: column;

  .header {
    height: 60px;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    box-shadow: 0 1px 0 0 rgba(232, 232, 232, 1);
    border-radius: 2px 2px 0 0;

    .go-back {
      cursor: pointer;
      margin-left: 20px;
      // font-weight: 500;
      font-weight: 500;
      line-height: 16px;
      display: flex;
      align-items: center;

      .icon {
        font-size: 18px;
        color: #000;
      }

      .txt {
        font-size: 16px;
        color: #262626;
      }

      // &:hover {
      //   opacity: 0.8;
      // }
    }

    h3 {
      font-size: 16px;
      line-height: 16px;
      margin-left: 24px;
      color: #262626;
    }
  }

  .form-content {
    margin-left: 30px;
    height: 100%;
    overflow: auto;
  }

  .form {
    margin-left: 30px;
    height: 100%;
    overflow: auto;

    /deep/ .el-date-editor {
      width: 320px !important;
    }

    /deep/ .add-btn {
      height: 40px;
      display: flex;
      align-items: center;

      .add-course,
      .add-exam {
        height: 32px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 0 12px !important;
        cursor: pointer;
        color: #1b9aee;
        border: 1px solid #ccecff;
        border-radius: 4px;
        margin: 0 16px 0 0 !important;
      }
    }

    .mk-form-item-name {
      margin-top: 26px;
    }

    .mk-form-item-end-time,
    .mk-form-item-dm-list,
    .mk-form-item-task-content {
      margin-top: -10px;
    }
  }

  .course-exam-list {
    margin-top: 12px;

    .course-exam-list-item {
      width: 360px;
      // height: 106px;
      box-sizing: border-box;
      border-radius: 4px;
      border: 1px solid #e8e8e8;
      margin-bottom: 15px;

      .info {
        display: flex;

        img {
          width: 48px;
          height: 48px;
          border-radius: 2px;
          margin: 12px;
        }

        .course-icon {
          background-color: #009cff;
        }

        .exam-icon {
          background-color: #54c366;
        }

        .main-info {
          .main-info-name {
            font-size: 14px;
            line-height: 20px;
            margin: 12px 0 8px 0;
            color: #262626;
            font-weight: 500;
          }

          .main-info-condition {
            font-size: 13px;
            line-height: 18px;
            color: #595959;
          }
        }
      }

      .hanlde-item {
        height: 32px;
        border-top: 1px solid #e8e8e8;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .hanlde-item-btn {
          margin-left: 0 !important;
          margin-right: 15px !important;

          /deep/ span {
            font-size: 13px;
          }
        }
      }
    }
  }

  /deep/ .name-input {
    input {
      color: #bfbfbf;
      font-size: 12px;
      padding-right: 44px;
    }
  }
}
</style>
